import { localization } from './localization'
export default () => ({
  isEditMode: false,
  editedServiceDetails: {} as MazInterfaces.ClientMaintenance.ContactService,
  loader: {
    clientServices: false
  },
  ...localization
})
